import React from "react";
import { Modal, Button } from "react-bootstrap";
import { LuTriangleAlert } from "react-icons/lu";

export default function ConfirmModal({
  show,
  onHide,
  onConfirm,
  title = "Are you sure?",
  message = "This action cannot be undone. Please confirm to proceed.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "brand", // 'brand', 'danger', 'success', 'warning'
  icon: Icon = LuTriangleAlert,
  loading = false,
}) {
  const getColors = () => {
    switch (variant) {
      case "danger":
        return {
          bg: "rgba(220, 53, 69, 0.1)",
          text: "#dc3545",
          btnBg: "#dc3545",
          btnBorder: "#dc3545",
          btnHover: "#bd2130",
        };
      case "warning":
        return {
          bg: "rgba(255, 193, 7, 0.1)",
          text: "#ffc107",
          btnBg: "#ffc107",
          btnBorder: "#ffc107",
          btnHover: "#e0a800",
        };
      case "success":
        return {
          bg: "rgba(40, 167, 69, 0.1)",
          text: "#28a745",
          btnBg: "#28a745",
          btnBorder: "#28a745",
          btnHover: "#218838",
        };
      case "brand":
      default:
        return {
          bg: "rgba(40, 176, 196, 0.1)",
          text: "#28B0C4",
          btnBg: "#28B0C4",
          btnBorder: "#28B0C4",
          btnHover: "#208e9e",
        };
    }
  };

  const colors = getColors();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      contentClassName="border-0 shadow-lg rounded-4 overflow-hidden"
      size="sm"
    >
      <Modal.Body className="text-center p-4">
        <div
          className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
          style={{
            width: "60px",
            height: "60px",
            backgroundColor: colors.bg,
            color: colors.text,
          }}
        >
          <Icon size={28} />
        </div>

        <h5 className="fw-bold text-dark mb-2">{title}</h5>
        <p className="text-muted small mb-4 px-2">{message}</p>

        <div className="d-flex flex-column gap-2">
          <Button
            style={{
              backgroundColor: colors.btnBg,
              borderColor: colors.btnBorder,
              color: "#fff",
              fontWeight: "600",
            }}
            className="rounded-pill py-2 shadow-sm d-flex align-items-center justify-content-center"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Processing..." : confirmText}
          </Button>
          <Button
            variant="light"
            className="rounded-pill py-2 text-muted fw-medium border-0"
            onClick={onHide}
            disabled={loading}
          >
            {cancelText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
